var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bar"}},[_c('h3',{staticClass:"p-3 text-white"},[_vm._v("出行城市排行")]),_c('div',{attrs:{"id":"city_rank"}})])
}]

export { render, staticRenderFns }